import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ProductFeatures() {
  const headerAnimation = useScrollAnimation({ threshold: 0.2 });
  const imagesAnimation = useScrollAnimation({ threshold: 0.2 });
  const ingredientsAnimation = useScrollAnimation({ threshold: 0.1 });
  const additionalAnimation = useScrollAnimation({ threshold: 0.2 });

  const ingredients = [
    {
      icon: 'https://public.readdy.ai/ai/img_res/875c3e5e28e5df6e074386fe0bb0180d.jpg',
      name: '3種のセラミド',
      description: 'セラミド NG/セラミドNP/セラミドAP',
      detail: `［肌バリア機能をサポート］
人も動物も加齢によるセラミド不足は心配。
セラミドNG・セラミドNP・セラミドAPの3種のセラミド配合で、お肌の水分保持とバリア機能をサポート。​`
    },
    {
      icon: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20icon%20design%20for%20hyaluronic%20acid%20skincare%20ingredient%2C%20soft%20beige%20and%20white%20color%20palette%2C%20elegant%20and%20clean%20aesthetic%2C%20luxury%20cosmetic%20product%20style%2C%20simple%20geometric%20shape%20with%20subtle%20gradient%2C%20professional%20beauty%20industry%20visual%2C%20high-end%20spa%20atmosphere&width=200&height=200&seq=icon-hyaluronic&orientation=squarish',
      name: 'ヒアルロン酸Na',
      description: '贅沢保湿成分',
      detail: `［高い保湿力と持続性］
リップクリームにも使用される贅沢保湿成分を配合。​うるおいヴェールで被毛を艶やかに。​`
    },
    {
      icon: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/2dfcfae399bfb0bd3b980599f9c8252f.png',
      name: (
        <>
          グリチルレチン酸ステアリル<br />
          グリチルリチン酸2K
        </>
      ),
      description: '甘草由来成分',
      detail: '［肌を整える植物成分］古来から使用されている、甘草（Glycyrrhiza）由来の優れた整肌保湿成分​です。'
    },
    {
      icon: 'https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/25dd6ad761efbdd40e032f8b9f1d551b.png',
      name: 'ホワイトリリィ',
      description: '上質な香り',
      detail: '［優雅で控えめな芳香］モニター様のご協力により、人にとって心地よく犬猫にとっても負担にならない香りにたどりつきました。季節や産地により揺らぐことのないサイエンス香料で365日安定した香りをお届けします。​'
    }
  ];

  return (
    <section className="py-32 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div 
          ref={headerAnimation.ref}
          className={`text-center mb-20 space-y-6 transition-all duration-1000 ${
            headerAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h3 className="text-sm tracking-[0.3em] text-stone-500 font-light" style={{ fontFamily: 'Cormorant, serif' }}>
            INGREDIENTS
          </h3>
          <h2 className="text-4xl md:text-5xl leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400, color: '#705e44' }}>
            極上のスキンケア発想から生まれた、<br />こだわりの成分
          </h2>
        </div>

        {/* Pet Images */}
        <div 
          ref={imagesAnimation.ref}
          className={`grid md:grid-cols-3 gap-8 mb-20 transition-all duration-1000 delay-200 ${
            imagesAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <div className="aspect-square w-full overflow-hidden">
            <img
              src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/b5d4641c58ec2fa6f1843f81d0d9a04d.png"
              alt="犬のケア"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="aspect-square w-full overflow-hidden">
            <img
              src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/44fa50da4b77a52a3ca6054b320eb5c2.png"
              alt="猫のケア"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="aspect-square w-full overflow-hidden">
            <img
              src="https://static.readdy.ai/image/6d9cd499b3569668e27a60fbbc899b03/1bb2d46f3c15546814ec4ef2188aca18.png"
              alt="ヨークシャテリア"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* Ingredients Grid */}
        <div 
          ref={ingredientsAnimation.ref}
          className="grid md:grid-cols-2 lg:grid-cols-4 gap-12"
        >
          {ingredients.map((ingredient, index) => (
            <div 
              key={index} 
              className={`text-center space-y-6 transition-all duration-1000 ${
                ingredientsAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-32 h-32 mx-auto flex items-center justify-center">
                <img
                  src={ingredient.icon}
                  alt={typeof ingredient.name === 'string' ? ingredient.name : '成分'}
                  className="w-full h-full object-cover rounded-full"
                  onError={(e) => {
                    console.error(`Failed to load image for ingredient ${index}`);
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <div className="space-y-3">
                <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500, color: '#705e44' }}>
                  {ingredient.name}
                </h4>
                <p className="text-sm text-stone-600" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500 }}>
                  {ingredient.description}
                </p>
                <p className="text-sm text-stone-500 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                  {ingredient.detail}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Features */}
        <div 
          ref={additionalAnimation.ref}
          className={`mt-20 pt-16 border-t border-stone-200 transition-all duration-1000 ${
            additionalAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="text-center space-y-3">
              <div className="w-32 h-32 mx-auto flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20circular%20icon%20design%20showing%20protective%20shield%20barrier%20against%20static%20electricity%2C%20soft%20beige%20and%20white%20color%20palette%20with%20subtle%20lightning%20bolt%20symbols%20being%20blocked%2C%20elegant%20and%20clean%20aesthetic%2C%20luxury%20cosmetic%20product%20style%2C%20simple%20geometric%20shape%20with%20subtle%20gradient%2C%20professional%20beauty%20industry%20visual%2C%20high-end%20spa%20atmosphere%2C%20anti-static%20protection%20concept&width=200&height=200&seq=icon-antistatic-shield&orientation=squarish"
                  alt="静電気防止"
                  className="w-full h-full object-cover rounded-full"
                  onError={(e) => {
                    console.error('Failed to load antistatic shield image');
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500, color: '#705e44' }}>
                静電気を防ぐ成分配合
              </h4>
              <p className="text-sm text-stone-500 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                グリセリンのうるおい＋帯電防止成分が​、ごわつく毛並みもなめらかブラッシング。​
              </p>
            </div>
            <div className="text-center space-y-3">
              <div className="w-32 h-32 mx-auto flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20circular%20icon%20design%20for%20free%20formula%20skincare%20ingredient%2C%20soft%20beige%20and%20white%20color%20palette%2C%20elegant%20and%20clean%20aesthetic%2C%20luxury%20cosmetic%20product%20style%2C%20simple%20geometric%20shape%20with%20subtle%20gradient%2C%20professional%20beauty%20industry%20visual%2C%20high-end%20spa%20atmosphere&width=200&height=200&seq=icon-free-formula&orientation=squarish"
                  alt="安心のフリー処方"
                  className="w-full h-full object-cover rounded-full"
                  onError={(e) => {
                    console.error('Failed to load free formula image');
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500, color: '#705e44' }}>
                動物に優しいフリー処方
              </h4>
              <p className="text-xs text-stone-500 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                パラベン・鉱物油・タール色素・アルコール・シリコン・紫外線吸収剤・合成着色料 不使用。​</p>
            </div>
            <div className="text-center space-y-3">
              <div className="w-32 h-32 mx-auto flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20circular%20icon%20design%20with%20elegant%20dog%20and%20cat%20silhouettes%20side%20by%20side%20in%20center%2C%20soft%20beige%20and%20white%20color%20palette%2C%20elegant%20and%20clean%20aesthetic%2C%20luxury%20cosmetic%20product%20style%2C%20simple%20geometric%20shape%20with%20subtle%20gradient%2C%20professional%20beauty%20industry%20visual%2C%20high-end%20spa%20atmosphere%2C%20pet-safe%20care%20concept%20for%20both%20dogs%20and%20cats&width=200&height=200&seq=icon-dog-cat-safe&orientation=squarish"
                  alt="犬猫にも安心"
                  className="w-full h-full object-cover rounded-full"
                  onError={(e) => {
                    console.error('Failed to load cat safe image');
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500, color: '#705e44' }}>
                犬猫にも安心
              </h4>
              <p className="text-xs text-stone-500 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                プロピレングリコール・キシリトール・安息香酸ナトリウム・過ホウ酸ナトリウム　不使用
              </p>
            </div>
            <div className="text-center space-y-3">
              <div className="w-32 h-32 mx-auto flex items-center justify-center">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20circular%20icon%20design%20featuring%20Japanese%20flag%20Hinomaru%20red%20circle%20on%20soft%20beige%20and%20white%20background%2C%20elegant%20and%20clean%20aesthetic%2C%20luxury%20cosmetic%20product%20style%2C%20simple%20geometric%20shape%20with%20subtle%20gradient%2C%20professional%20beauty%20industry%20visual%2C%20high-end%20spa%20atmosphere%2C%20Made%20in%20Japan%20quality%20symbol&width=200&height=200&seq=icon-japan-flag-hinomaru&orientation=squarish"
                  alt="Made in Japan"
                  className="w-full h-full object-cover rounded-full"
                  onError={(e) => {
                    console.error('Failed to load made in japan image');
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>
              <h4 className="text-xl" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 500, color: '#705e44' }}>
                Made in Japan
              </h4>
              <p className="text-xs text-stone-500 leading-relaxed" style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}>
                製造から出荷までの全行程を日本国内で管理。こだわりの日本製
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
